import React from "react"
import { useState, useEffect } from "react"
import { updateRegistro, iniciarDia, addSolicitudCambioReg } from "../../../firebase/firebase"
import { ModalSolicitudCambioReg } from "./ModalSolicitudCambioReg"
import { useModalSolicitudCambioReg } from "./UseModalSolicitudCambioReg"
import { capitalize, formatAñoMes, formatDate, formatFecha, formatFechaVisual, formatFechaYHoraFromTimestamp, formatHour, formatHourFromTimestamp, formatMayus, formatNumber, sumarDias } from "../../../js/functions"
import { PROJECT_APP, ECINNOVA, INSERTATOLEDO, CARITASTOLEDO } from "./../../../js/project"
import { BLANK, REASONS_JUSTIFIED_PAUSE, REASONS_NOT_WORKING, TRABAJADOR_SOCIAL } from "../../../js/consts"

export const ModalsSolicitudCambioReg = ({ registro, fechaDia, trabajador, onChangeRegistro, horario }) => {
  const [isOpenModal, openModal, closeModal] = useModalSolicitudCambioReg(false)
  const [arrPausas, setArrPausas] = useState([])
  const [stateCheckboxDiaTrabajado, setStateCheckboxDiaTrabajado] = useState(true)
  const [comentario, setComentario] = useState("")
  const [editarPausas, setEditarPausas] = useState(false)
  const [horasInicio, setHorasInicio] = useState("")
  const [minutosInicio, setMinutosInicio] = useState("")
  const [horasFin, setHorasFin] = useState("")
  const [minutosFin, setMinutosFin] = useState("")
  const [horasInicioPausa, setHorasInicioPausa] = useState("")
  const [minutosInicioPausa, setMinutosInicioPausa] = useState("")
  const [horasFinPausa, setHorasFinPausa] = useState("")
  const [minutosFinPausa, setMinutosFinPausa] = useState("")
  const [numeroPausa, setNumeroPausa] = useState(null)
  const [motivoLibre, setMotivoLibre] = useState(BLANK)
  const [pausaJornadaPartida, setPausaJornadaPartida] = useState(true)
  const [pausaPersonal, setPausaPersonal] = useState(false)
  const [pausaJustificada, setPausaJustificada] = useState(false)
  const [comentarioPausa, setComentarioPausa] = useState("")
  const [comentarioDiaCompleto, setComentarioDiaCompleto] = useState("")
  const [mensajeError, setMensajeError] = useState("")
  const [mensajeErrorPausa, setMensajeErrorPausa] = useState("")
  const [botonBorrarPausa, setBotonBorrarPausa] = useState(false)
  const [selectPausaJustificada, setSelectPausaJustificada] = useState(BLANK)
  const [dispositivoFichajeInicioPausa, setDispositivoFichajeInicioPausa] = useState(null)
  const [dispositivoFichajeFinPausa, setDispositivoFichajeFinPausa] = useState(null)

  const fechaDiaSiguiente = formatDate(sumarDias(new Date(fechaDia), +1))

  const [fechaSelectInicio, setFechaSelectInicio] = useState(fechaDia)
  const [fechaSelectFin, setFechaSelectFin] = useState(fechaDia)
  const [fechaSelectInicioPausa, setFechaSelectInicioPausa] = useState(fechaDia)
  const [fechaSelectFinPausa, setFechaSelectFinPausa] = useState(fechaDia)

  const [trazabilidad, setTrazabilidad] = useState(null)
  const [enabledBotonAddPausa, setEnabledBotonAddPausa] = useState(true)

  const [motivoSolicitud, setMotivoSolicitud] = useState("")

  const [pausasModificadas, setPausasModificadas] = useState([])
  
  const [teletrabajo, setTeletrabajo] = useState(false)
  const [teletrabajoPausa, setTeletrabajoPausa] = useState(false)

  useEffect(() => {
    setPausas(registro)
    if(registro.trabajado !== undefined) {
      if (registro.trabajado === true) setStateCheckboxDiaTrabajado(registro.trabajado)
      else setStateCheckboxDiaTrabajado(false)
    } 
    else setStateCheckboxDiaTrabajado(true)

    if(registro.inicio !== undefined) setHorasInicio(registro.inicio.toDate().getHours())
    if(registro.inicio !== undefined) setMinutosInicio(registro.inicio.toDate().getMinutes())
    if(registro.fin !== undefined) setHorasFin(registro.fin.toDate().getHours())
    if(registro.fin !== undefined) setMinutosFin(registro.fin.toDate().getMinutes())
    if(registro.motivoLibre !== undefined) setMotivoLibre(registro.motivoLibre)
    if(registro.comentarioLibre !== undefined) setComentario(registro.comentarioLibre)
    if(registro.comentarioDiaCompleto !== undefined) setComentarioDiaCompleto(registro.comentarioDiaCompleto)
    if(registro.teletrabajo !== undefined) setTeletrabajo(registro.teletrabajo)

    if(registro.inicio !== undefined) setFechaSelectInicio(formatDate(registro.inicio.toDate()))
    if(registro.fin !== undefined) setFechaSelectFin(formatDate(registro.fin.toDate()))

    if (registro !== undefined && registro !== "") definirTrazabilidad(registro)
    if (registro !== undefined && registro !== "") confirmarBotonAddPausa(registro)
  }, [])

  function confirmarBotonAddPausa(registroAux) {
    if(registroAux.pausas !== undefined && registroAux.pausas !== null && registroAux.pausas[registroAux.pausas.length - 1].fin === undefined) {
      setEnabledBotonAddPausa(false)
    }
    else {
      setEnabledBotonAddPausa(true)
    }
  }

  function definirTrazabilidad(registroAux) {
    let trazabilidadActual = []
    // console.log(registroAux);

    if (registroAux.inicio !== undefined) {
      trazabilidadActual.push({
        campo: "inicio",
        valor: registroAux.inicio,
        creadoEl: registroAux.fechaCambioInicio !== undefined ? registroAux.fechaCambioInicio : registroAux.inicio,
        creadoPor: registroAux.nombreAdminCambioInicio !== undefined ? registroAux.nombreAdminCambioInicio : trabajador.name,
        role: registroAux.nombreAdminCambioInicio !== undefined ? "admin" : "trabajador",
        modalidad: registroAux.teletrabajo === true ? "teletrabajo" : "presencial",
        ...(registroAux.motivoSolicitudInicio !== undefined && { motivoSolicitud: registroAux.motivoSolicitudInicio })
      })
    }

    if (registroAux.pausas !== undefined && registroAux.pausas !== null) {
      registroAux.pausas.forEach((pausa, index) => {
        trazabilidadActual.push({
          campo: `pausa ${index + 1}`,
          valor: `${formatHourFromTimestamp(pausa.inicio.seconds !== undefined ? pausa.inicio.seconds * 1000 : pausa.inicio)} - ${pausa.fin !== undefined ? formatHourFromTimestamp(pausa.fin.seconds !== undefined ? pausa.fin.seconds * 1000 : pausa.fin) : ""}` ,
          creadoEl: pausa.fechaCambioPausa !== undefined ? pausa.fechaCambioPausa : pausa.inicio,
          creadoPor: pausa.nombreAdminCambioPausa !== undefined ? pausa.nombreAdminCambioPausa : trabajador.name,
          modalidad: pausa.teletrabajo === true ? "teletrabajo" : "presencial",
          role: pausa.nombreAdminCambioPausa !== undefined ? "admin" : "trabajador"
        })
      })
    }

    if (registroAux.fin !== undefined) {
      trazabilidadActual.push({
        campo: "fin",
        valor: registroAux.fin,
        creadoEl: registroAux.fechaCambioFin !== undefined ? registroAux.fechaCambioFin : registroAux.fin,
        creadoPor: registroAux.nombreAdminCambioFin !== undefined ? registroAux.nombreAdminCambioFin : trabajador.name,
        modalidad: registroAux.teletrabajo === true ? "teletrabajo" : "presencial",
        role: registroAux.nombreAdminCambioFin !== undefined ? "admin" : "trabajador",
        ...(registroAux.motivoSolicitudFin !== undefined && { motivoSolicitud: registroAux.motivoSolicitudFin })
      })
    }

    let trazabilidadAux = null

    if (registroAux.trazabilidad !== undefined) {
      trazabilidadAux = trazabilidadActual.concat(registroAux.trazabilidad)
    }
    else {
      trazabilidadAux = trazabilidadActual
    }

    trazabilidadAux.sort((a, b) => (b.creadoEl.seconds !== undefined ? b.creadoEl.seconds * 1000 : b.creadoEl) - (a.creadoEl.seconds !== undefined ? a.creadoEl.seconds * 1000 : a.creadoEl));

    // console.log(trazabilidadAux);

    setTrazabilidad(trazabilidadAux)
  }

  function setPausas(registro) {
    let pausas = "", pausasFinal = []
    if(registro.pausas !== undefined) pausas = registro !== "" ? registro.pausas : ""

    if (pausas !== "" && pausas !== null) {
      for (let i = 0; i<pausas.length; i++) {
        if (pausas[i] !== undefined) {
          if(pausas[i].inicio.seconds !== undefined) {
            if (pausas[i].fin !== undefined) {
              pausasFinal.push(formatHour(pausas[i].inicio.toDate().getHours(), pausas[i].inicio.toDate().getMinutes()) + " - " + formatHour(pausas[i].fin.toDate().getHours(), pausas[i].fin.toDate().getMinutes()))
            }
            else {
              pausasFinal.push(formatHour(pausas[i].inicio.toDate().getHours(), pausas[i].inicio.toDate().getMinutes()))
            }
          }
          else {
            if (pausas[i].fin !== undefined){
              pausasFinal.push(formatHour(pausas[i].inicio.getHours(), pausas[i].inicio.getMinutes()) + " - " + formatHour(pausas[i].fin.getHours(), pausas[i].fin.getMinutes()))
            }
            else {
              pausasFinal.push(formatHour(pausas[i].inicio.getHours(), pausas[i].inicio.getMinutes()))
            }
          }
        }
      }
    }
    setArrPausas(pausasFinal)
  }

  function onChangeCheckbox(e) {
    if (e.target.value === "true") {
      setStateCheckboxDiaTrabajado(false)
      if (registro !== "") {
        registro.trabajado = false
      }
    }
    if (e.target.value === "false") {
      setStateCheckboxDiaTrabajado(true)
      if (registro !== "") {
        registro.trabajado = true
      }
    }
    setMensajeError("")
  }

  function modificarPausa (e) {
    setBotonBorrarPausa(true)
    setEditarPausas(true)
    setMensajeErrorPausa("")
    // console.log(e.target.title)
    setNumeroPausa(e.target.title)
    if (registro.pausas[e.target.title].dispositivoInicio !== undefined) {
      setDispositivoFichajeInicioPausa(registro.pausas[e.target.title].dispositivoInicio)
    }
    else {
      setDispositivoFichajeInicioPausa(null)
    }
    if (registro.pausas[e.target.title].dispositivoFin !== undefined) {
      setDispositivoFichajeFinPausa(registro.pausas[e.target.title].dispositivoFin)
    }
    else {
      setDispositivoFichajeFinPausa(null)
    }
    if (registro.pausas[e.target.title].tipo === 2) {
      setSelectPausaJustificada(registro.pausas[e.target.title].tipoPausaJustificada)
    }
    else {
      setSelectPausaJustificada(BLANK)
    }
    if(registro.pausas[e.target.title].inicio.seconds !== undefined) {
      if (registro.pausas[e.target.title].inicio !== undefined) {
        setHorasInicioPausa(registro.pausas[e.target.title].inicio.toDate().getHours())
        setMinutosInicioPausa(registro.pausas[e.target.title].inicio.toDate().getMinutes())
        setFechaSelectInicioPausa(formatDate(registro.pausas[e.target.title].inicio.toDate()))
      }
      if (registro.pausas[e.target.title].fin !== undefined) {
        setHorasFinPausa(registro.pausas[e.target.title].fin.toDate().getHours())
        setMinutosFinPausa(registro.pausas[e.target.title].fin.toDate().getMinutes())
        setFechaSelectFinPausa(formatDate(registro.pausas[e.target.title].fin.toDate()))
        setTeletrabajoPausa(registro.pausas[e.target.title].teletrabajo ?? false)
      }
    }
    else {
      if (registro.pausas[e.target.title].inicio !== undefined) {
        setHorasInicioPausa(registro.pausas[e.target.title].inicio.getHours())
        setMinutosInicioPausa(registro.pausas[e.target.title].inicio.getMinutes())
        setFechaSelectInicioPausa(formatDate(registro.pausas[e.target.title].inicio))
      }
      if (registro.pausas[e.target.title].fin !== undefined) {
        setHorasFinPausa(registro.pausas[e.target.title].fin.getHours())
        setMinutosFinPausa(registro.pausas[e.target.title].fin.getMinutes())
        setFechaSelectFinPausa(formatDate(registro.pausas[e.target.title].fin))
        setTeletrabajoPausa(registro.pausas[e.target.title].teletrabajo ?? false)
      }
    }
    
    if (registro.pausas[e.target.title].tipo !== undefined && registro.pausas[e.target.title].tipo === 0) { 
      setPausaJornadaPartida(true); 
      setPausaPersonal(false);
      setPausaJustificada(false);
      setComentarioPausa("")
    }
    else if (registro.pausas[e.target.title].tipo !== undefined && registro.pausas[e.target.title].tipo === 1) { 
      setPausaJornadaPartida(false); 
      setPausaPersonal(true);
      setPausaJustificada(false);
      if (registro.pausas[e.target.title].comentarioPausa !== undefined) setComentarioPausa(registro.pausas[e.target.title].comentarioPausa)
      else if (registro.pausas[e.target.title].comentarioPausa !== undefined) setComentarioPausa("")
    }
    else if (registro.pausas[e.target.title].tipo !== undefined && registro.pausas[e.target.title].tipo === 2) { 
      setPausaJornadaPartida(false); 
      setPausaPersonal(false);
      setPausaJustificada(true);
      if (registro.pausas[e.target.title].comentarioPausa !== undefined) setComentarioPausa(registro.pausas[e.target.title].comentarioPausa)
      else if (registro.pausas[e.target.title].comentarioPausa !== undefined) setComentarioPausa("")
    }
  }

  function añadirPausa() {
    setBotonBorrarPausa(false)
    setEditarPausas(true)
    setNumeroPausa(null)
    setHorasInicioPausa("")
    setMinutosInicioPausa("")
    setHorasFinPausa("")
    setMinutosFinPausa("")
    setComentarioPausa("")
    setPausaJornadaPartida(true)
    setPausaPersonal(false)
    setPausaJustificada(false)
    setSelectPausaJustificada(BLANK)
    setMensajeErrorPausa("")
    setDispositivoFichajeInicioPausa(null)
    setDispositivoFichajeFinPausa(null)
    setFechaSelectInicioPausa(fechaDia)
    setFechaSelectFinPausa(fechaDia)
  }
    
  function confirmarPausa() {
    if (horasInicioPausa > -1 && horasInicioPausa < 24) {} else { setMensajeErrorPausa("Hora inicio incorrecta"); return "" }
    if (horasFinPausa > -1 && horasFinPausa < 24) {} else { setMensajeErrorPausa("Hora fin incorrecta"); return "" }
    if (minutosInicioPausa > -1 && minutosInicioPausa < 60) {} else { setMensajeErrorPausa("Minutos inicio incorrectos"); return "" }
    if (minutosFinPausa > -1 && minutosFinPausa < 60) {} else { setMensajeErrorPausa("Minutos fin incorrectos"); return "" }
    if (horasInicioPausa === "") { setMensajeErrorPausa("Escribe la hora de inicio"); return "" }
    if (minutosInicioPausa === "") { setMensajeErrorPausa("Escribe los minutos de inicio"); return "" }

    if (pausaJustificada === true) if (selectPausaJustificada === BLANK) { setMensajeErrorPausa("Selecciona motivo pausa justificada"); return "" }
    setMensajeErrorPausa("")

    const trazabilidadCambioPausas = []

    const pausaAux = {
      inicio: new Date(formatFecha(fechaSelectInicioPausa)+" "+horasInicioPausa+":"+minutosInicioPausa+":00"),
      fechaCambioPausa: new Date(),
      nombreAdminCambioPausa: "NOMBRE_ADMIN",
      ...(teletrabajoPausa && { teletrabajo: true })
    }

    if (horasFinPausa !== "" && minutosFinPausa !== "") {
      pausaAux.fin = new Date(formatFecha(fechaSelectFinPausa)+" "+horasFinPausa+":"+minutosFinPausa+":00")
    } 


    if (pausaJornadaPartida === true) { 
      pausaAux.tipo = 0 
    }
    else if (pausaPersonal === true) { 
      pausaAux.tipo = 1
      pausaAux.comentarioPausa = comentarioPausa 
    }
    else if (pausaJustificada === true) { 
      pausaAux.tipo = 2
      pausaAux.comentarioPausa = comentarioPausa
      pausaAux.tipoPausaJustificada = selectPausaJustificada 
    }

    if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
      // Nada porque no añado dispositivo de inicio (ordenador/movil)
    }
    else if (PROJECT_APP === CARITASTOLEDO) {
      pausaAux.dispositivoInicio = "ORDENADOR"
      if (horasFinPausa !== "" && minutosFinPausa !== "") {
        pausaAux.dispositivoFin = "ORDENADOR"
      }
    }

    // Editando pausa
    if (numeroPausa !== null) {
      if (registro.pausas[numeroPausa] !== registro.pausas[registro.pausas.length - 1]) {
        if (horasFinPausa === "") { setMensajeErrorPausa("Escribe la hora de fin"); return "" }
        if (minutosFinPausa === "") { setMensajeErrorPausa("Escribe los minutos de fin"); return "" }
      }

      let inicioPausa = null
      let finPausa = null

      if (registro.pausas[numeroPausa].inicio.seconds !== undefined) inicioPausa = new Date(registro.pausas[numeroPausa].inicio.seconds * 1000)
      else inicioPausa = registro.pausas[numeroPausa].inicio

      if (registro.pausas[numeroPausa].fin !== undefined && registro.pausas[numeroPausa].fin.seconds !== undefined) finPausa = new Date(registro.pausas[numeroPausa].fin.seconds * 1000)
      else finPausa = registro.pausas[numeroPausa].fin

      if ((`${formatNumber(inicioPausa.getHours())}:${formatNumber(inicioPausa.getMinutes())}` !== `${formatNumber(horasInicioPausa)}:${formatNumber(minutosInicioPausa)}`) || 
      (finPausa !== undefined && `${formatNumber(finPausa.getHours())}:${formatNumber(finPausa.getMinutes())}` !== `${formatNumber(horasFinPausa)}:${formatNumber(minutosFinPausa)}`) ||
      (registro.pausas[numeroPausa].teletrabajo !== teletrabajoPausa)) {
        trazabilidadCambioPausas.push({
          campo: `pausa ${parseInt(numeroPausa) + 1}`,
          valor: `${formatHourFromTimestamp(inicioPausa)} - ${registro.pausas[numeroPausa].fin !== undefined ? formatHourFromTimestamp(finPausa) : ""}` ,
          creadoEl: registro.pausas[numeroPausa].fechaCambioPausa !== undefined ? registro.pausas[numeroPausa].fechaCambioPausa : inicioPausa,
          creadoPor: registro.pausas[numeroPausa].nombreAdminCambioPausa !== undefined ? registro.pausas[numeroPausa].nombreAdminCambioPausa : trabajador.name,
          modalidad: registro.pausas[numeroPausa].teletrabajo === true ? "teletrabajo" : "presencial",
          role: registro.pausas[numeroPausa].nombreAdminCambioPausa !== undefined ? "admin" : "trabajador",
          ...(registro.motivoSolicitudPausa !== undefined && { motivoSolicitud: registro.motivoSolicitudPausa })
        })
      }

      setPausasModificadas(prev => [...prev, numeroPausa]);
      registro.pausas[numeroPausa] = pausaAux
    }

    // Añadiendo pausa
    else {
      if (registro.pausas === null || registro.pausas === undefined) registro.pausas = []
      registro.pausas.push(pausaAux)

      setPausasModificadas(prev => [...prev, registro.pausas.length - 1]);
      registro.pausas[numeroPausa] = pausaAux
    }

    let trazabilidadAux = null

    if (registro.trazabilidad !== undefined) {
      trazabilidadAux = trazabilidadCambioPausas.concat(registro.trazabilidad)
    }
    else {
      trazabilidadAux = trazabilidadCambioPausas
    }

    // trazabilidadAux.sort((a, b) => (b.creadoEl.seconds !== undefined ? b.creadoEl.seconds * 1000 : b.creadoEl) - (a.creadoEl.seconds !== undefined ? a.creadoEl.seconds * 1000 : a.creadoEl));

    registro.trazabilidad = trazabilidadAux

    setHorasInicioPausa("")
    setMinutosInicioPausa("")
    setHorasFinPausa("")
    setMinutosFinPausa("")
    setComentarioPausa("")
    setMensajeErrorPausa("")
    setPausaJornadaPartida(true)
    setPausaPersonal(false)
    setPausaJustificada(false)
    setDispositivoFichajeInicioPausa(null)
    setDispositivoFichajeFinPausa(null)
    setTeletrabajoPausa(false)

    setPausas(registro)
    confirmarBotonAddPausa(registro)
    definirTrazabilidad(registro)

    setEditarPausas(false)
  }

  async function confirmarModal() {
    if (motivoSolicitud === "" || motivoSolicitud === " ") {setMensajeError("Indica motivo de la solicitud"); return ""}
    if (horasInicio > -1 && horasInicio < 24) {} else { setMensajeError("Hora inicio incorrecta"); return "" }
    if (horasFin > -1 && horasFin < 24) {} else { setMensajeError("Hora fin incorrecta"); return "" }
    if (minutosInicio > -1 && minutosInicio < 60) {} else { setMensajeError("Minutos inicio incorrectos"); return "" }
    if (minutosFin > -1 && minutosFin < 60) {} else { setMensajeError("Minutos fin incorrectos"); return "" }
    setMensajeError("")

    const trazabilidadCambio = []

  
    // Si es distinto el registro de la base de datos y lo que está en pantalla (solo teletrabajo)
    if (registro.teletrabajo !== teletrabajo) {
      trazabilidadCambio.push({
        campo: "inicio",
        valor: registro.inicio,
        creadoEl: registro.fechaCambioInicio !== undefined ? registro.fechaCambioInicio : registro.inicio,
        creadoPor: registro.nombreAdminCambioInicio !== undefined ? registro.nombreAdminCambioInicio : trabajador.name,
        modalidad: registro.teletrabajo === true ? "teletrabajo" : "presencial",
        role: registro.nombreAdminCambioInicio !== undefined ? "admin" : "trabajador",
        ...(registro.motivoSolicitudInicio !== undefined && { motivoSolicitud: registro.motivoSolicitudInicio })
      })
    }

    // Si es distinto el registro de la base de datos y lo que está en pantalla (solo inicio)
    if (registro.inicio !== undefined && `${formatNumber(registro.inicio.toDate().getHours())}:${formatNumber(registro.inicio.toDate().getMinutes())}` !== 
    `${formatNumber(horasInicio)}:${formatNumber(minutosInicio)}`) {
      trazabilidadCambio.push({
        campo: "inicio",
        valor: registro.inicio,
        creadoEl: registro.fechaCambioInicio !== undefined ? registro.fechaCambioInicio : registro.inicio,
        creadoPor: registro.nombreAdminCambioInicio !== undefined ? registro.nombreAdminCambioInicio : trabajador.name,
        modalidad: registro.teletrabajo === true ? "teletrabajo" : "presencial",
        role: registro.nombreAdminCambioInicio !== undefined ? "admin" : "trabajador",
        ...(registro.motivoSolicitudInicio !== undefined && { motivoSolicitud: registro.motivoSolicitudInicio })
      })
      registro.fechaCambioInicio = new Date()
      registro.nombreAdminCambioInicio = "NOMBRE_ADMIN"
      registro.motivoSolicitudInicio = motivoSolicitud
    }

    if (registro.inicio === undefined && horasInicio > -1 && horasInicio < 24 && minutosInicio > -1 && minutosInicio < 60 && horasInicio !== "" && minutosInicio !== "") {
      registro.fechaCambioInicio = new Date()
      registro.nombreAdminCambioInicio = "NOMBRE_ADMIN"
      registro.motivoSolicitudInicio = motivoSolicitud
    }

    // Si es distinto el registro de la base de datos y lo que está en pantalla (solo fin)
    if (registro.fin !== undefined && `${formatNumber(registro.fin.toDate().getHours())}:${formatNumber(registro.fin.toDate().getMinutes())}` !== 
    `${formatNumber(horasFin)}:${formatNumber(minutosFin)}`) {
      trazabilidadCambio.push({
        campo: "fin",
        valor: registro.fin,
        creadoEl: registro.fechaCambioFin !== undefined ? registro.fechaCambioFin : registro.fin,
        creadoPor: registro.nombreAdminCambioFin !== undefined ? registro.nombreAdminCambioFin : trabajador.name,
        modalidad: registro.teletrabajo === true ? "teletrabajo" : "presencial",
        role: registro.nombreAdminCambioFin !== undefined ? "admin" : "trabajador",
        ...(registro.motivoSolicitudFin !== undefined && { motivoSolicitud: registro.motivoSolicitudFin })
      })
      registro.fechaCambioFin = new Date()
      registro.nombreAdminCambioFin = "NOMBRE_ADMIN"
      registro.motivoSolicitudFin = motivoSolicitud
    }

    if (registro.fin === undefined && horasFin > -1 && horasFin < 24 && minutosFin > -1 && minutosFin < 60 && horasFin !== "" && minutosFin !== "") {
      registro.fechaCambioFin = new Date()
      registro.nombreAdminCambioFin = "NOMBRE_ADMIN"
      registro.motivoSolicitudFin = motivoSolicitud
    }

    if (registro.inicio !== undefined) registro.inicio = new Date(formatFecha(fechaSelectInicio)+" "+horasInicio+":"+minutosInicio+":00")
    if (registro.fin !== undefined) registro.fin = new Date(formatFecha(fechaSelectFin)+" "+horasFin+":"+minutosFin+":00")

    let inicio = ""

    if (horasInicio !== "" && minutosInicio !== "") { inicio = new Date(formatFecha(fechaSelectInicio)+" "+horasInicio+":"+minutosInicio+":00"); }

    if (inicio === "") { setMensajeError("Escribe hora de inicio"); return "" }
    else {
      registro.trabajado = true
      registro.inicio = inicio
      if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
        // Nada porque no añado dispositivo
      }
      else if (PROJECT_APP === CARITASTOLEDO) {
        registro.dispositivoInicio = "ORDENADOR"
      }
    } 
    
    if (horasFin !== "" && minutosFin !== "") { 
      registro.fin = new Date(formatFecha(fechaSelectFin)+" "+horasFin+":"+minutosFin+":00")
      if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
        // Nada porque no añado dispositivo
      }
      else if (PROJECT_APP === CARITASTOLEDO) {
        registro.dispositivoFin = "ORDENADOR" 
      }
    }

    if (registro.motivoLibre !== undefined) registro.motivoLibre = ""
    if (registro.comentarioLibre !== undefined) registro.comentarioLibre = ""
    if (comentarioDiaCompleto !== "") registro.comentarioDiaCompleto = comentarioDiaCompleto
    
    if (registro.teletrabajo === true && teletrabajo !== true) delete registro.teletrabajo
    else if (registro.teletrabajo !== true && teletrabajo === true) registro.teletrabajo = true

    if (pausasModificadas.length !== 0) {
      pausasModificadas.forEach(numeroPausa => {
        registro.pausas[numeroPausa].motivoSolicitudPausa = motivoSolicitud
      })

      pausasModificadas.length = 0
    }


    let trazabilidadAux = null

    if (registro.trazabilidad !== undefined) {
      trazabilidadAux = trazabilidadCambio.concat(registro.trazabilidad)
    }
    else {
      trazabilidadAux = trazabilidadCambio
    }

    trazabilidadAux.sort((a, b) => b.creadoEl.seconds - a.creadoEl.seconds);

    registro.trazabilidad = trazabilidadAux

    registro.datosTrabajador = {
      name: `${trabajador.name}`,
      apellidos: `${trabajador.apellidos}`,
      email: `${trabajador.email}`,
      fecha: `${fechaDia}`,
      uid: `${trabajador.uid}`,
      id: `${fechaDia}_${trabajador.uid}`,
      motivoSolicitud: motivoSolicitud
    }
    
    // await updateRegistro(trabajador.uid, fechaDia, registro)
    await addSolicitudCambioReg(trabajador, fechaDia, registro)
    // console.log(registro)

    onChangeRegistro()
    definirTrazabilidad(registro)
    confirmarBotonAddPausa(registro)
    closeModal()
  }

  async function confirmarNoTrabajado() {
    if (motivoSolicitud === "" || motivoSolicitud === " ") {setMensajeError("Indica motivo de la solicitud"); return ""}
    if (motivoLibre === BLANK) {setMensajeError("Selecciona motivo"); return ""}
    else {
      registro.motivoLibre = motivoLibre
      registro.comentarioLibre = comentario
      registro.trabajado = false
      registro.motivoSolicitudBaja = motivoSolicitud

      registro.datosTrabajador = {
        name: `${trabajador.name}`,
        apellidos: `${trabajador.apellidos}`,
        email: `${trabajador.email}`,
        fecha: `${fechaDia}`,
        uid: `${trabajador.uid}`,
        id: `${fechaDia}_${trabajador.uid}`,
        motivoSolicitud: motivoSolicitud
      }
      
      // await updateRegistro(trabajador.uid, fechaDia, registro)
      await addSolicitudCambioReg(trabajador, fechaDia, registro)
      onChangeRegistro()
      closeModal() 
    }
  }

  async function crearRegistroNoTrabajado() {
    if (motivoSolicitud === "" || motivoSolicitud === " ") {setMensajeError("Indica motivo de la solicitud"); return ""}
    if (motivoLibre === BLANK) {setMensajeError("Selecciona motivo dia libre"); return ""}
    else {
      const añoMes = formatAñoMes(new Date(fechaDia));
      const año = new Date(fechaDia).getFullYear();

      const registroDB = {
        fecha: fechaDia,
        añomes: añoMes,
        año: `${año}`,
        comentarioLibre: comentario,
        motivoLibre: motivoLibre,
        trabajado: false,
        motivoSolicitudBaja: motivoSolicitud
      }

      registroDB.datosTrabajador = {
        name: `${trabajador.name}`,
        apellidos: `${trabajador.apellidos}`,
        email: `${trabajador.email}`,
        fecha: `${fechaDia}`,
        uid: `${trabajador.uid}`,
        id: `${fechaDia}_${trabajador.uid}`,
        motivoSolicitud: motivoSolicitud
      }
  
      // await iniciarDia(trabajador, registroDB, fechaDia)
      await addSolicitudCambioReg(trabajador, fechaDia, registroDB)
      onChangeRegistro()
      closeModal()
    }
  }

  async function crearRegistroTrabajado() {
    if (motivoSolicitud === "" || motivoSolicitud === " ") {setMensajeError("Indica motivo de la solicitud"); return ""}

    const añoMes = formatAñoMes(new Date(fechaDia));
    const año = new Date(fechaDia).getFullYear();

    if (horasInicio > -1 && horasInicio < 24) {} else { setMensajeError("Hora inicio incorrecta"); return "" }
    if (horasFin > -1 && horasFin < 24) {} else { setMensajeError("Hora fin incorrecta"); return "" }
    if (minutosInicio > -1 && minutosInicio < 60) {} else { setMensajeError("Minutos inicio incorrectos"); return "" }
    if (minutosFin > -1 && minutosFin < 60) {} else { setMensajeError("Minutos fin incorrectos"); return "" }
    setMensajeError("")

    let inicio = "", fin = ""

    if (horasInicio !== "" && minutosInicio !== "") inicio = new Date(formatFecha(fechaSelectInicio)+" "+horasInicio+":"+minutosInicio+":00")
    if (horasFin !== "" && minutosFin !== "") fin = new Date(formatFecha(fechaSelectFin)+" "+horasFin+":"+minutosFin+":00")

    if (inicio === "") { setMensajeError("Escribe hora de inicio"); return "" }
    else {
      const registroDB = {
        fecha: fechaDia,
        añomes: añoMes,
        año: `${año}`,
        inicio: inicio,
        fechaCambioInicio: new Date(),
        nombreAdminCambioInicio: "NOMBRE_ADMIN",
        motivoSolicitudInicio: motivoSolicitud,
        trabajado: true,
        ...(teletrabajo && { teletrabajo: true })
      }
      if (fin !== "") {
        registroDB.fin = fin
        registroDB.fechaCambioFin = new Date()
        registroDB.nombreAdminCambioFin = "NOMBRE_ADMIN"
        registroDB.motivoSolicitudFin = motivoSolicitud
      }

      if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
        // Nada porque no añado dispositivos
      }
      else if (PROJECT_APP === CARITASTOLEDO) {
        registroDB.dispositivoInicio = "ORDENADOR"

        if (fin !== "") {
          registroDB.dispositivoFin = "ORDENADOR"
        }
      }

      registroDB.datosTrabajador = {
        name: `${trabajador.name}`,
        apellidos: `${trabajador.apellidos}`,
        email: `${trabajador.email}`,
        fecha: `${fechaDia}`,
        uid: `${trabajador.uid}`,
        id: `${fechaDia}_${trabajador.uid}`,
        motivoSolicitud: motivoSolicitud
      }
      
      // await iniciarDia(trabajador, registroDB, fechaDia);
      await addSolicitudCambioReg(trabajador, fechaDia, registroDB);

      onChangeRegistro()
      // definirTrazabilidad(registroDB)
      closeModal()
    }
  }

  function borrarPausa() {
    registro.pausas.splice(numeroPausa, 1)

    if (registro.pausas.length < 1) {
      registro.pausas = null
    }

    setBotonBorrarPausa(false)

    setHorasInicioPausa("")
    setMinutosInicioPausa("")
    setHorasFinPausa("")
    setMinutosFinPausa("")
    setComentarioPausa("")
    setPausaJornadaPartida(true)
    setDispositivoFichajeInicioPausa(null)
    setDispositivoFichajeFinPausa(null)
    
    setPausas(registro)
    confirmarBotonAddPausa(registro)

    setEditarPausas(false)
  }

  function onChangePausaJornadaPartida(e) {
    if (e.target.value === "false") {
    setPausaJornadaPartida(true);
    setPausaPersonal(false);
    setPausaJustificada(false);
    }
  }
    
  function onChangePausaPersonal(e) {
    if (e.target.value === "false") {
      setPausaJornadaPartida(false);
      setPausaPersonal(true);
      setPausaJustificada(false);
    }
  }
    
  function onChangePausaJustificada(e) {
    if (e.target.value === "false") {
      setPausaJornadaPartida(false);
      setPausaPersonal(false);
      setPausaJustificada(true);
    }
  }

  if (registro !== undefined) {
    return (
      <>
        <button className="acceptButton" onClick={openModal}>Solicitar Cambio</button>
        <ModalSolicitudCambioReg isOpen={isOpenModal} closeModal={closeModal}>
          <article id="editRecords">
            <div className="titulo2">Registro de {trabajador.name} del {formatFechaVisual(fechaDia)}</div>
            <hr />
            <label className="marginbottom-8 dblock">
              <input type="checkbox" checked={stateCheckboxDiaTrabajado} defaultValue={stateCheckboxDiaTrabajado} onChange={onChangeCheckbox} />
              &nbsp;Dia trabajado
            </label>

            {stateCheckboxDiaTrabajado === false &&
              <div>
                <label>
                  <div className="marginbottom-8">Selecciona el motivo por el que no se ha trabajado ese dia:</div>
                  <select className="marginbottom-8" value={motivoLibre} onChange={(e) => {setMotivoLibre(e.target.value)}}>
                    <option key={BLANK} value={BLANK}></option>
                    {REASONS_NOT_WORKING.map((reason) => (
                      <option key={reason} value={reason}>{formatMayus(reason)}</option>
                    ))}
                  </select>
                </label>
                <br />
                <textarea placeholder="Comentarios:" value={comentario} cols="30" rows="3" onChange={(e) => {setComentario(e.target.value)}}></textarea>
              </div>
            }

            {stateCheckboxDiaTrabajado === true &&
              <>
                <div className="dInlineTextArea">
                  <article>
                    <div className="marginbottom-8">
                      Inicio&nbsp;&nbsp;
                      <input type="text" defaultValue={horasInicio} onChange={(e) => {setHorasInicio(e.target.value)}} />
                      &nbsp;:&nbsp;
                      <input type="text" defaultValue={minutosInicio} onChange={(e) => {setMinutosInicio(e.target.value)}} />
                      <div className="dinline paddingleft-8">
                        <select value={fechaSelectInicio} onChange={(e) => {setFechaSelectInicio(e.target.value)}}>
                          <option key={fechaDia} value={fechaDia}>{fechaDia}</option>
                          <option key={fechaDiaSiguiente} value={fechaDiaSiguiente}>{fechaDiaSiguiente}</option>
                        </select>
                      </div>
                      {registro.dispositivoInicio !== undefined &&
                        // <div className="mleft-50"><sup>Fichado desde {registro.dispositivoInicio}</sup></div>
                        <div className="mleft-50"><sup>&nbsp;</sup></div>
                      }
                    </div>
                    <div className="marginbottom-8">
                      Fin &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <input type="text" defaultValue={horasFin} onChange={(e) => {setHorasFin(e.target.value)}} />
                      &nbsp;:&nbsp;
                      <input type="text" defaultValue={minutosFin} onChange={(e) => {setMinutosFin(e.target.value)}} />
                      <div className="dinline paddingleft-8">
                        <select value={fechaSelectFin} onChange={(e) => {setFechaSelectFin(e.target.value)}}>
                          <option key={fechaDia} value={fechaDia}>{fechaDia}</option>
                          <option key={fechaDiaSiguiente} value={fechaDiaSiguiente}>{fechaDiaSiguiente}</option>
                        </select>
                      </div>
                      {registro.dispositivoFin !== undefined &&
                        // <div className="mleft-50"><sup>Fichado desde {registro.dispositivoFin}</sup></div>
                        <div className="mleft-50"><sup>&nbsp;</sup></div>
                      }
                    </div>
                    <div className=" presencialTeletrabajoRegistro">
                      <label>
                        Presencial
                        <input type="checkbox" checked={!teletrabajo} onChange={() => setTeletrabajo(false)} />
                      </label>
                      <label>
                        Teletrabajo
                        <input type="checkbox" checked={teletrabajo} onChange={() => setTeletrabajo(true)} />
                      </label>
                    </div>
                  </article>
                </div>
              
                { registro !== "" && 
                  <>
                    <br />
                    <div>
                      <div className="text-bold">Pausas:</div>
                      <div className="paddingy-8">
                        {arrPausas.map((pausa, index) => (
                          <button className="transparentButton" title={index} key={index} onClick={modificarPausa}>{pausa}</button>
                        ))}
                      </div>
                    </div>
                    <div>
                      <button disabled={!enabledBotonAddPausa} className="acceptButton" onClick={añadirPausa}>Añadir Pausa</button>
                    </div>
                    <section className="flexPausas">
                      <article className="margintop-8">
                        <div className="marginbottom-8">
                          Inicio Pausa&nbsp;&nbsp;
                          <input type="text" disabled={!editarPausas} value={horasInicioPausa} onChange={(e) => {setHorasInicioPausa(e.target.value)}} />
                          &nbsp;:&nbsp;
                          <input type="text" disabled={!editarPausas} value={minutosInicioPausa} onChange={(e) => {setMinutosInicioPausa(e.target.value)}} />
                          <div className="dinline paddingleft-8">
                            <select value={fechaSelectInicioPausa} disabled={!editarPausas} onChange={(e) => {setFechaSelectInicioPausa(e.target.value)}}>
                              <option key={fechaDia} value={fechaDia}>{fechaDia}</option>
                              <option key={fechaDiaSiguiente} value={fechaDiaSiguiente}>{fechaDiaSiguiente}</option>
                            </select>
                          </div>
                          {dispositivoFichajeInicioPausa !== null &&
                            // <div className="mleft-95"><sup>Fichado desde {dispositivoFichajeInicioPausa}</sup></div>
                            <div className="mleft-95"><sup>&nbsp;</sup></div>
                          }
                          {dispositivoFichajeInicioPausa === null &&
                            <div><sup>&nbsp;</sup></div>
                          }
                        </div>
                        <div className="marginbottom-8">
                          Fin pausa &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <input type="text" disabled={!editarPausas} value={horasFinPausa} onChange={(e) => {setHorasFinPausa(e.target.value)}} />
                          &nbsp;:&nbsp;
                          <input type="text" disabled={!editarPausas} value={minutosFinPausa} onChange={(e) => {setMinutosFinPausa(e.target.value)}} />
                          <div className="dinline paddingleft-8">
                            <select value={fechaSelectFinPausa} disabled={!editarPausas} onChange={(e) => {setFechaSelectFinPausa(e.target.value)}}>
                              <option key={fechaDia} value={fechaDia}>{fechaDia}</option>
                              <option key={fechaDiaSiguiente} value={fechaDiaSiguiente}>{fechaDiaSiguiente}</option>
                            </select>
                          </div>
                          {dispositivoFichajeFinPausa !== null &&
                            // <div className="mleft-95"><sup>Fichado desde {dispositivoFichajeFinPausa}</sup></div>
                            <div className="mleft-95"><sup>&nbsp;</sup></div>
                          }
                          {dispositivoFichajeFinPausa === null &&
                            <div><sup>&nbsp;</sup></div>
                          }
                        </div>
                        <div className="marginbottom-8 presencialTeletrabajoRegistro">
                          <label>
                            Presencial
                            <input type="checkbox" disabled={!editarPausas} checked={!teletrabajoPausa} onChange={() => setTeletrabajoPausa(false)} />
                          </label>
                          <label>
                            Teletrabajo
                            <input type="checkbox" disabled={!editarPausas} checked={teletrabajoPausa} onChange={() => setTeletrabajoPausa(true)} />
                          </label>
                        </div>
                      </article>

                      <article>
                        <span className="text-bold">&nbsp;Tipo pausa &nbsp;</span>
                        <select disabled={!pausaJustificada} value={selectPausaJustificada} onChange={(e) => {setSelectPausaJustificada(e.target.value)}}>
                          <option key={BLANK} value={BLANK}></option>

                          { PROJECT_APP === ECINNOVA && 
                            <></>
                          }
                          { PROJECT_APP === INSERTATOLEDO && 
                            <option key={TRABAJADOR_SOCIAL} value={TRABAJADOR_SOCIAL}>{formatMayus(TRABAJADOR_SOCIAL)}</option>
                          }
                          { PROJECT_APP === CARITASTOLEDO && 
                            <></>
                          }

                          {REASONS_JUSTIFIED_PAUSE.map((reason) => (
                            <option key={reason} value={reason}>{formatMayus(reason)}</option>
                          ))}
                        </select>
                      </article>
                    
                      <article>
                        <label>
                          <input type="checkbox" disabled={!editarPausas} checked={pausaJornadaPartida} value={pausaJornadaPartida} onChange={onChangePausaJornadaPartida} /> 
                          Pausa jornada partida 
                        </label>
                        <label>
                          <input type="checkbox" disabled={!editarPausas} checked={pausaPersonal} value={pausaPersonal} onChange={onChangePausaPersonal} /> 
                          Pausa personal
                        </label>
                        <label>
                          <input type="checkbox" disabled={!editarPausas} checked={pausaJustificada} value={pausaJustificada} onChange={onChangePausaJustificada} /> 
                          Pausa justificada
                        </label>
                      </article>
                      
                      <article>
                        <textarea disabled={pausaJornadaPartida} value={comentarioPausa} onChange={(e) => {setComentarioPausa(e.target.value)}} placeholder="Mas informacion..." cols="30" rows="3" />
                      </article>
                    </section>
                    
                    <div className="pauseButtons">
                      <button disabled={!botonBorrarPausa} className="cancelButton" onClick={borrarPausa}>Borrar pausa</button>
                      <button disabled={!editarPausas} className="acceptButton" onClick={confirmarPausa}>Confirmar pausa</button>
                      <span className="colorred">&nbsp;{mensajeErrorPausa}</span>
                    </div>

                    {trazabilidad !== null && 
                      <>
                        {/* <div className="text-bold">Trazabilidad del registro de {trabajador.name} del {formatFechaVisual(registro.fecha)}</div>
                        <table>
                          <thead>
                            <tr>
                              <th>Campo</th>
                              <th>Valor</th>
                              <th>Creado el</th>
                              <th>Creado por</th>
                              <th>Modalidad</th>
                              <th>Role</th>
                            </tr>
                          </thead>
                          <tbody>
                            {trazabilidad.map((item, index) => (
                              <tr key={index}>
                                <td>{capitalize(item.campo)}</td>
                                <td>{item.campo.includes("pausa") ? item.valor : item.valor.seconds !== undefined ? formatHourFromTimestamp(item.valor.seconds * 1000) : formatHourFromTimestamp(item.valor)}</td>
                                <td>{item.creadoEl.seconds !== undefined ? formatFechaYHoraFromTimestamp(item.creadoEl.seconds * 1000) : formatFechaYHoraFromTimestamp(item.creadoEl)}</td>
                                <td>{item.creadoPor}</td>
                                <td> {(() => {if (item.modalidad === "teletrabajo") return "Teletrabajo"; else return "Presencial"; })()}</td>
                                <td>{capitalize(item.role)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <hr /> */}
                      </>
                    }
                  </>
                }
              </>
            }

            <hr />

            <div className="buttonsRecords">
              <label> 
                <span>Motivo solicitud →</span>
                <input type="text" value={motivoSolicitud} onChange={(e) => setMotivoSolicitud(e.target.value)} />
              </label>

              <div>
                <span className="colorred">{mensajeError}&nbsp;</span>
                <button className="cancelButton" onClick={closeModal}>Cancelar</button>
                {stateCheckboxDiaTrabajado === false && 
                  <>
                    { registro === "" && 
                      <button className="acceptButton" onClick={crearRegistroNoTrabajado}>Aceptar</button>
                    }
                    { registro !== "" && 
                      <button className="acceptButton" onClick={confirmarNoTrabajado}>Aceptar</button>
                    }
                  </>
                }
                {stateCheckboxDiaTrabajado === true && 
                  <>
                    { registro === "" && 
                      <button className="acceptButton" onClick={crearRegistroTrabajado}>Aceptar</button>
                    }
                    { registro !== "" && 
                      <button className="acceptButton" onClick={confirmarModal}>Aceptar</button> 
                    }
                  </>
                }
                
              </div>
            </div>

          </article>
        </ModalSolicitudCambioReg>
      </>
    )
  }
}